import BaseStateMachine from '../state-machine/baseStateMachine'
import { steps } from '@/models/createWarehouseReceivingOrder/steps'

import { store } from '@/store'
import router from '@/router'
import { WarehouseReceivingOrdersEnum } from '@/enums/modules/routes'

export const machineSteps = steps

export const computeStepIndex = (stepName) => {
  let index = -1
  for (let i = 0; i < machineSteps.length; i++) {
    const step = machineSteps[i].stateNode
    if (step.name === stepName) {
      index = i
      break
    }
  }
  return index + 1
}

const routeToWroView = () => {
  const cachedRoute = store.getters['warehouseReceivingOrders/cachedRoute']
  if (cachedRoute !== null) {
    router.push({...cachedRoute})
  } else {
    router.push({
      name: WarehouseReceivingOrdersEnum.WarehouseReceivingOrders,
      params: {
        view: WarehouseReceivingOrdersEnum.AllView
      }
    })
  }
}

let rootMachine = {
  key: 'create-wro',
  initial: '',
  states: {
    cancelled: {}
  },
  on: {
    CANCEL: {
      cancelled: {
        actions: [routeToWroView]
      }
    }
  }
}

for (let i = 0; i < steps.length; i++) {
  const stepNumber = i + 1
  const step = steps[i].stateNode
  const nextStep = steps[i + 1]
  const previousStepsNodes = steps.slice(0, i).map(step => step.stateNode)
  const nextStepNode = nextStep && nextStep.stateNode
  const stateNodeGeneratorArgs = { nextStepNode, previousStepsNodes, stepNumber, history: step.history }
  if (i === 0) rootMachine.initial = step.name
  rootMachine.states[step.name] = step.stateNodeGenerator(stateNodeGeneratorArgs)
}

export class CreateWroMachine extends BaseStateMachine {
  constructor () {
    super({ ...rootMachine })
    this.visited = new Set()
  }
}

export const machine = new CreateWroMachine()
